import { Text, TouchableOpacity, View, StyleSheet } from "react-native";
import { StatusBar } from "expo-status-bar";
import { Ionicons } from "@expo/vector-icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { disableBackgroundPlayback } from "../../redux/slices/playbackSlice";
import { t } from "../../i18n/strings";

export default function ScreenCover() {
  const visible = useSelector(
    (state: RootState) => state.playback.screenCoverVisible,
  );
  const dispatch: AppDispatch = useDispatch();

  if (!visible) {
    return null;
  }

  return (
    <View style={styles.cover}>
      <StatusBar hidden />
      <TouchableOpacity
        accessibilityRole="button"
        onPress={() => dispatch(disableBackgroundPlayback())}
        style={styles.button}
      >
        <Ionicons color="#e9ddff" size={30} name="moon" />
        <Text style={styles.buttonText}>{t("playbackBackground")}</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  cover: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "black",
    elevation: 9999,
    zIndex: 9999,
  },
  button: {
    position: "absolute",
    right: 18,
    bottom: 36,
    alignItems: "center",
    padding: 10,
  },
  buttonText: {
    color: "#e9ddff",
    fontSize: 12,
    fontWeight: "700",
    marginTop: 4,
  },
});
